<template>
  <div class="form-group skill-formdata">
    <multiselect
      v-model="date"
      @input="updateData"
      @remove="cleareData"
      :searchable="false"
      :loading="isLoading"
      :options="dates"
      :placeholder="placeholder"
      :clearOnSelect="false"
      :closeOnSelect="true"
      :preserveSearch="true"
      label="title"
      track-by="title"
    >
      <template slot="singleLabel" slot-scope="props">
        <div
          class="mr-1"
          style="font-size: 14px;white-space: nowrap;overflow: hidden;"
        >{{ props.option.title }}</div>
      </template>
      <template slot="option" slot-scope="props">
        <div
          class="mr-1"
          style="font-size: 14px;white-space: nowrap;overflow: hidden;"
        >{{ props.option.title }}</div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "task-execution-date",
  components: {
    Multiselect
  },
  props: ["place_holder", "value"],
  data() {
    return {
      date: null,
      dates: [],
      placeholder: "Select an execution date",
      isLoading: false
    };
  },
  created() {
    if (
      this.place_holder != "" &&
      this.place_holder != null &&
      this.place_holder != undefined
    ) {
      this.placeholder = this.place_holder;
    }

    let self = this;
    self.isLoading = true;
    axios({
      method: "get",
      url: "/api/v1/task-execution-date/all"
    })
      .then(function(response) {
        self.isLoading = false;
        if (response.data.ok) {
          self.dates = response.data.data;
        }
      })
      .catch(function(err) {
        self.isLoading = false;
        self.errors = err.response.data.errors;
      });
  },
  methods: {
    updateData: function(value) {
      this.$emit("input", value.id);
      this.$emit("getExecutionDate", value.title);
    },
    cleareData: function() {
      this.$emit("input", null);
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        if (
          this.date == null &&
          this.value != null &&
          this.value != undefined &&
          this.value != ""
        ) {
          let self = this;
          self.isLoading = true;
          axios({
            method: "get",
            url: "/api/v1/task-execution-date/" + self.value + "/show"
          })
            .then(function(response) {
              self.isLoading = false;
              if (response.data.ok) {
                self.date = response.data.data;
              }
            })
            .catch(function(err) {
              self.isLoading = false;
              self.errors = err.response.data.errors;
            });
        }
      }
    }
  }
};
</script>
